import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { observer } from 'mobx-react-lite';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { PaymentServiceWithVersionsResponseType } from '../../../../../api/types/payments/payment-template';
import { SettingsBranches } from '../../../../../api/types/settings/branches/settings-branches';
import { addPaymentServiceOperation } from '../operations/add-payment-service-operation';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { PaymentServicesTable } from '../../../../payments/tabs/componenets/payment-services-table';

interface AddPaymentServiceDialogProps {
  visible: boolean;
  onHide: () => void;
  user: UserSummaryType;
}

export const AddPaymentServiceDialog: React.FC<AddPaymentServiceDialogProps> =
  observer(({ visible, onHide, user }) => {
    const [selectedService, setSelectedService] =
      useState<PaymentServiceWithVersionsResponseType | null>(null);
    const [selectedBranch, setSelectedBranch] =
      useState<SettingsBranches | null>(null);
    const [loading, setLoading] = useState(false);

    // Bumping this key remounts the shared PaymentServicesTable, so its
    // internal filter / pagination state start fresh every time the dialog
    // reopens (matches the original behavior that cleared the inline filter
    // input on `visible` change).
    const [tableKey, setTableKey] = useState(0);

    useEffect(() => {
      if (visible) {
        setSelectedService(null);
        setSelectedBranch(null);
        setTableKey((k) => k + 1);
      }
    }, [visible]);

    const handleApprove = async () => {
      if (!selectedService || !selectedBranch) {
        return;
      }

      // Use the latest price version (first in versions array)
      const latestPrice = selectedService.versions[0];

      await addPaymentServiceOperation(
        user.id,
        selectedBranch.id,
        selectedService.id,
        latestPrice.id,
        setLoading,
        onHide,
      );
    };

    const isApproveDisabled = !selectedService || !selectedBranch || loading;

    const branchTemplate = (option: SettingsBranches) => {
      return <div>{option.branchName}</div>;
    };

    return (
      <Dialog
        header="הוסף שירות תשלום לתלמיד"
        visible={visible}
        onHide={onHide}
        style={{ width: '800px' }}
        modal
      >
        <div style={{ marginBottom: '20px' }}>
          <label
            htmlFor="branch-dropdown"
            style={{ display: 'block', marginBottom: '8px' }}
          >
            בחר סניף:
          </label>
          <Dropdown
            id="branch-dropdown"
            value={selectedBranch}
            options={globalSettingsBranches.branches}
            onChange={(e) => setSelectedBranch(e.value)}
            itemTemplate={branchTemplate}
            optionLabel="branchName"
            placeholder="בחר סניף"
            style={{ width: '100%' }}
          />
        </div>

        <PaymentServicesTable
          key={tableKey}
          selectionMode="single"
          selectedService={selectedService}
          onSingleSelectionChange={setSelectedService}
        />

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            marginTop: '20px',
            paddingBottom: '10px',
          }}
        >
          <Button label="ביטול" onClick={onHide} severity="secondary" />
          <div style={{ width: '10px' }} />
          <Button
            label="אישור"
            onClick={handleApprove}
            loading={loading}
            tooltip={
              isApproveDisabled
                ? 'יש לבחור שלוחה וסוג שרות תשלום לפני האישור'
                : 'הוספת שרות תשלום לתלמיד'
            }
            tooltipOptions={{ showOnDisabled: true }}
            disabled={isApproveDisabled}
          />
        </div>
      </Dialog>
    );
  });
